import { Button } from "@shared/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { Download } from "lucide-react";
import { useDownloadBills, useExportBillData } from "../../hooks";

interface QuickActionsCardProps {
  runId: string;
}

export const QuickActionsCard = ({ runId }: QuickActionsCardProps) => {
  const exportBillData = useExportBillData();
  const downloadBills = useDownloadBills();
  const handleExportBillData = async () => {
    try {
      await exportBillData.mutateAsync(runId);
    } catch (error) {
      console.error("View failed:", error);
      // showToast('Failed to view the bill', 'error');
    } // Implementation
  };

  const handleDownloadBills = async () => {
    await downloadBills.mutateAsync({ runId: runId });
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">Quick Actions</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-1">
          <Button
            variant="outline"
            className="w-full justify-start"
            onClick={handleExportBillData}
          >
            <Download className="h-4 w-4 mr-2" />
            Export Bill Data
          </Button>
          <Button
            variant="outline"
            className="w-full justify-start"
            onClick={handleDownloadBills}
          >
            <Download className="h-4 w-4 mr-2" />
            Download Bills
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
